import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "../../common/Slider";
import CommonModal from "../../common/CommonModal";
import TestimonialItem from "./TestimonialItem";

function Testimonial({ setTab }) {
  const reviews = [
    {
      name: "Prabhat Kumar",
      address: "Kuju, Ramgarh",
      description:
        "Prasad Eye Hospital offers exceptional care with highly skilled doctors and state-of-the-art facilities.",
      rating: 5,
      img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/testimonial/prabhat.jpg",
      imgAlt: "prabhat",
    },
    {
      name: "Arun Kumar",
      address: "Hazaribagh",
      description:
        "Excellent work done by the whole team of Prasad Eye Hospital, Ramgarh",
      rating: 5,
      img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/testimonial/testimonial2.jpg",
      imgAlt: "testimonial2",
    },
    {
      name: "Deepak Kumar",
      address: "Ramgarh",
      description:
        "One of the best Eye Care Hospital in Jharkhand with professional doctors and good staff.",
      rating: 5,
      img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/testimonial/testimonial3.jpg",
      imgAlt: "testimonial3",
    },
    {
      name: "Mithun Kumar",
      address: "Bokaro",
      description:
        "The best part of this centre is that you will feel satisfied after meeting Dr. Indranath Prasad, as he listens to all your problems. The treatment here is excellent.",
      rating: 5,
      img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/testimonial/testimonial1.jpg",
      imgAlt: "testimonial1",
    },
  ];
  const [currReview, setCurrReview] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (review) => {
    setCurrReview(review);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <section className="ttm-row only_title-section ttm-bgcolor-darkgrey ttm-bgimage-yes bg-img4 ttm-bg clearfix">
        <div className="ttm-row-wrapper-bg-layer ttm-bg-layer"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title title-style-center_text">
                <div className="title-header">
                  <h3>Testimonials</h3>
                  <h2 className="title">What Our Patients Say!</h2>
                </div>
                <div className="heading-seperator">
                  <span></span>
                </div>
                <div className="title-desc">
                  <p>
                    What a wonderful experience with Prasad Eye Hospital! Your
                    doctor will make the best effort possible to diagnose eye
                    condition.
                  </p>
                </div>
              </div>
              <div className="padding_bottom60 res-991-padding_bottom0"></div>
            </div>
          </div>
        </div>
      </section>
      <section className="ttm-row top_zero_padding-section mt_130 res-991-margin_top50 clearfix">
        <div className="container">
          <div className="row">
            <Slider
              sliders={reviews.map((review) => (
                <TestimonialItem review={review} openModal={openModal} />
              ))}
              slidesToShow={3}
              autoplaySpeed={3000}
              responsive={true}
            />
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center margin_top35 mb_20 res-991-mt-20">
                <p>
                  <span className="font-weight-normal">
                    Don’t Hesitate, Contact us for Better Help and Services.{" "}
                  </span>
                  <br />
                  <Link
                    to="/appointment"
                    className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-border ttm-btn-color-dark margin_top15"
                    onClick={() => setTab("appointment")}
                  >
                    Book Appointment
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CommonModal
        open={isModalOpen}
        closeModal={closeModal}
        title="Customer Review"
        content={<TestimonialItem review={currReview} isModal={true} />}
      />
    </>
  );
}

export default Testimonial;
